import { render, staticRenderFns } from "./ClientOwnedVendor.vue?vue&type=template&id=da53b99e&scoped=true&"
import script from "./ClientOwnedVendor.vue?vue&type=script&lang=js&"
export * from "./ClientOwnedVendor.vue?vue&type=script&lang=js&"
import style0 from "./ClientOwnedVendor.vue?vue&type=style&index=0&id=da53b99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53b99e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VSpacer,VTooltip})
